import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { useIsomorphicLayoutEffect, useMediaQuery } from '@react-hookz/web';
import { createContext, useMemo, useState } from 'react';
export const BreakpointContext = createContext('xs');
export const BreakpointProvider = ({
  children,
  defaultBreakpoint = 'xs'
}) => {
  // this prevents initial hydration mismatches between server and client breakpoints
  const [state, setState] = useState(defaultBreakpoint);
  const theme = useTheme();
  // note:
  // due to sub-pixel rounding issues we don't use fixed ranges via min-max queries (where: max-width = next - 0.1 for example),
  // as this could lead to none of the queries matching at all for a brief moment during a viewport size change.
  const isSM = useMediaQuery(`(min-width: ${theme.breakpoints.sm}px)`);
  const isMD = useMediaQuery(`(min-width: ${theme.breakpoints.md}px)`);
  const isLG = useMediaQuery(`(min-width: ${theme.breakpoints.lg}px)`);
  const isXL = useMediaQuery(`(min-width: ${theme.breakpoints.xl}px)`);
  const breakpoint = useMemo(() => {
    if (isXL) {
      return 'xl';
    } else switch (true) {
      case isLG:
        {
          return 'lg';
        }
      case isMD:
        {
          return 'md';
        }
      case isSM:
        {
          return 'sm';
        }
      default:
        {
          return !isXL && !isLG && !isMD && !isSM && defaultBreakpoint ? defaultBreakpoint : 'xs';
        }
    }
  }, [defaultBreakpoint, isXL, isLG, isMD, isSM]);
  useIsomorphicLayoutEffect(() => {
    setState(breakpoint);
  }, [breakpoint, setState]);
  return _jsx(BreakpointContext.Provider, {
    value: state,
    children: children
  });
};